import { useEffect } from 'react';
import fscreen from 'fscreen';
export function useFullscreenEvents(_a) {
    var onFullscreenEntered = _a.onFullscreenEntered, onFullscreenExited = _a.onFullscreenExited;
    useEffect(function () {
        if (!onFullscreenEntered && !onFullscreenExited) {
            return;
        }
        var handleFullscreenChange = function () {
            if (fscreen.fullscreenElement) {
                onFullscreenEntered && onFullscreenEntered();
                return;
            }
            onFullscreenExited && onFullscreenExited();
        };
        fscreen.addEventListener('fullscreenchange', handleFullscreenChange);
        return function () {
            return fscreen.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, [onFullscreenEntered, onFullscreenExited]);
}
//# sourceMappingURL=useFullscreenEvents.js.map